"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _withSizePresets = _interopRequireDefault(require("./withSizePresets"));
var _styles = require("./styles");
/* eslint-disable max-len */

var X = function X(props) {
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, (0, _extends2["default"])({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.229 8.391l-3.385-3.386-7.843 7.838-7.84-7.84-3.386 3.385 7.609 7.608-7.613 7.612 3.385 3.386 7.843-7.838 7.84 7.841 3.387-3.386-7.61-7.608z"
  })));
};
var _default = (0, _withSizePresets["default"])(20, 20)(X);
exports["default"] = _default;
//# sourceMappingURL=X.js.map